var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3168 1.39504L0.106726 20.8094C-0.196713 21.3361 0.183063 21.9926 0.789943 21.9926H3.35867L11.313 7.90087C11.6145 7.36649 12.3855 7.36649 12.6871 7.90087L20.6414 21.9926H23.2101C23.817 21.9926 24.1967 21.3361 23.8933 20.8094L12.6813 1.39504C12.3779 0.868319 11.6183 0.868319 11.3149 1.39504H11.3168Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3282 14.0553L6.74609 21.9925H17.2519L12.6698 14.0553C12.3721 13.5382 11.6259 13.5382 11.3282 14.0553Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtela);
export default __webpack_public_path__ + "static/media/artela.1133d2d54057f4761115e0daa08a54a7.svg";
export { ForwardRef as ReactComponent };